const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://bek.rmiac18.ru:5000/api';

const parseResponse = async (response) => {
  const data = await response.json();
  if (!response.ok || data.success === false) {
    throw new Error(data.error || `HTTP ${response.status}`);
  }
  return data;
};

class TeamApi {
  async getAllTeams() {
    const response = await fetch(`${API_BASE_URL}/teams`);
    const data = await response.json();
    return data.data || data || [];
  }

  async createTeam(teamData) {
    const teamObject = typeof teamData === 'string'
      ? { name: teamData, description: '', department: '', leader: '', members: [], status: 'active' }
      : teamData;

    const response = await fetch(`${API_BASE_URL}/teams`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(teamObject),
    });

    const data = await parseResponse(response);
    return data.data;
  }

  async updateTeam(teamName, teamData) {
    const response = await fetch(`${API_BASE_URL}/teams/${encodeURIComponent(teamName)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(teamData),
    });

    const data = await parseResponse(response);
    return data.data;
  }

  async getTeam(teamName) {
    const response = await fetch(`${API_BASE_URL}/teams/${encodeURIComponent(teamName)}`);
    const data = await parseResponse(response);
    return data.data;
  }

  async updateTeamSteps(teamName, steps) {
    const response = await fetch(`${API_BASE_URL}/teams/${encodeURIComponent(teamName)}/steps`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ steps }),
    });

    const data = await parseResponse(response);
    return data.data;
  }

  async deleteTeam(teamName) {
    const response = await fetch(`${API_BASE_URL}/teams/${encodeURIComponent(teamName)}`, {
      method: 'DELETE',
    });

    const data = await parseResponse(response);
    return data.message;
  }

  async getTeamsStats() {
    const response = await fetch(`${API_BASE_URL}/teams/stats/overview`);
    const data = await parseResponse(response);
    return data.data;
  }

  async reorderTeams(order) {
    const response = await fetch(`${API_BASE_URL}/teams/reorder`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order }),
    });

    const data = await parseResponse(response);
    return data.data;
  }

  async checkApiHealth() {
    try {
      const response = await fetch(`${API_BASE_URL}/database/status`);
      const data = await response.json();
      return data.success === true;
    } catch (error) {
      console.error('API недоступен:', error);
      return false;
    }
  }
}

export default new TeamApi();
